module.exports = require("core-js-pure/features/json/stringify");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/json/stringify.js
// module id = 484
// module chunks = 13